import { useState } from "react";

interface MarginInputs {
  bill: number;
  rate: number;
  margin: number;
}

// Cashback as a share of the gross margin on one bill. Everything shown is
// derived from the three inputs.
export function useMarginCalculator(initial: MarginInputs) {
  const initialState = initial;
  const [state, setState] = useState(initialState);

  const setBill = (value: string) => {
    const bill = parseFloat(value);
    setState((state) => ({ ...state, bill: Number.isFinite(bill) && bill > 0 ? bill : 0 }));
  };
  const setRate = (rate: number) => setState((state) => ({ ...state, rate }));
  const setMargin = (margin: number) => setState((state) => ({ ...state, margin }));

  const cashback = Math.round(state.bill * state.rate) / 100;
  const grossMargin = (state.bill * state.margin) / 100;
  const share = grossMargin > 0 ? (cashback / grossMargin) * 100 : 0;

  return {
    ...state,
    setBill,
    setRate,
    setMargin,
    cashback,
    grossMargin,
    share,
    left: Math.max(0, grossMargin - cashback),
  };
}
